class PredictiveSearch extends HTMLElement {
	/**
	 * Constructor to initialize the PredictiveSearch component.
	 */
	constructor() {
		super();

		this.input = this.querySelector('input[type="search"]');
		this.predictiveSearchResults = this.querySelector('#predictive-search');
		this.predictiveSearchDefault = this.querySelector('#predictive-search-default');

		this.input.addEventListener(
			'input',
			this.debounce((event) => {
				this.onChange(event);
			}, 300).bind(this)
		);
	}

	/**
	 * Event handler for input changes.
	 */
	onChange() {
		const searchTerm = this.input.value.trim();

		if (!searchTerm.length) {
			this.close();
			return;
		}

		this.getSearchResults(searchTerm);
	}

	/**
	 * Fetch search results from the server based on the search term.
	 * 
	 * @param {string} searchTerm - The term to search for.
	 */
	getSearchResults(searchTerm) {
		fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
			.then((response) => {
				if (!response.ok) {
					var error = new Error(response.status);
					this.close();
					throw error;
				}

				return response.text();
			})
			.then((text) => {
				const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
				this.predictiveSearchResults.innerHTML = resultsMarkup;
				this.open();
			})
			.catch((error) => {
				this.close();
				throw error;
			});
	}

	/**
	 * Open the predictive search results container.
	 */
	open() {
		this.predictiveSearchResults.style.display = 'block';
		this.predictiveSearchDefault.style.display = 'none';
	}

	/**
	 * Close the predictive search results container.
	 */
	close() {
		this.predictiveSearchResults.style.display = 'none';
		this.predictiveSearchDefault.style.display = 'flex';
	}

	/**
	 * Debounce function to limit the rate at which a function can fire.
	 * 
	 * @param {Function} fn - The function to debounce.
	 * @param {number} wait - The number of milliseconds to delay.
	 * @returns {Function} - The debounced function.
	 */
	debounce(fn, wait) {
		let t;
		return (...args) => {
			clearTimeout(t);
			t = setTimeout(() => fn.apply(this, args), wait);
		};
	}
}

// Define the custom element
customElements.define('predictive-search', PredictiveSearch);